export const DesktopImgSizesConstant = [
  {
    width: 592,
    height: 424,
  },
  {
    width: 391,
    height: 250,
  },
  {
    width: 391,
    height: 164,
  },
  {
    width: 391,
    height: 164,
  },
  {
    width: 391,
    height: 250,
  },
];
